// packages/frontend/src/app/sections/Footer.tsx
import React from 'react';

type Props = {
  className?: string;
};

export default function Footer({ className }: Props) {
  return (
    <footer
      className={['section', 'section-footer', className].filter(Boolean).join(' ')}
      role="contentinfo"
      aria-label="Site footer"
    >
      {/* TODO: add real footer content */}
      <div className="container">
        <div className="footer-placeholder">Footer</div>
      </div>
    </footer>
  );
}
